@if (formLoading) {
  <div class="kbm-search-loading">
    <p-progressSpinner [style]="{width:'64px', height:'64px'}" strokeWidth="4"
                       fill="transparent" animationDuration=".6s"></p-progressSpinner>
    <span class="kbm-send-overlay-label">Sending quote, please wait…</span>
  </div>
}
<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button (click)="closePopUpOfQuote()" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>

  <!-- ==================================================== -->
  <!--  SMART-PARSE CONTEXT CHIP                              -->
  <!--  Appears when quote was opened from inbox + tape chart. -->
  <!--  Lets reservationist confirm we hydrated the form from -->
  <!--  the actual guest request and not just defaults.       -->
  <!-- ==================================================== -->
  @if (showContextChip && (quoteContext || incomingGuestInfo)) {
    <div class="quote-context-chip">
      <i class="pi pi-bolt"></i>
      <span class="qcc-label">Auto-filled from email:</span>
      @if (incomingGuestInfo?.guestName) {
        <span class="qcc-item"><i class="pi pi-user"></i> {{ incomingGuestInfo.guestName }}</span>
      }
      @if (incomingGuestInfo?.guestEmail) {
        <span class="qcc-item"><i class="pi pi-envelope"></i> {{ incomingGuestInfo.guestEmail }}</span>
      }
      @if (incomingGuestInfo?.guestPhone) {
        <span class="qcc-item"><i class="pi pi-phone"></i> {{ incomingGuestInfo.guestPhone }}</span>
      }
      <span class="qcc-item">
        <i class="pi pi-users"></i>
        {{ form1?.value?.numAdults || 2 }}A
        @if ((form1?.value?.numChildren || 0) > 0) {, {{ form1?.value?.numChildren }}C}
      </span>
      @if (quoteContext?.flexMode) {
        <span class="qcc-item qcc-flex">
          <i class="pi pi-sync"></i> Flexible {{ quoteContext.flexNumNights }} nights
        </span>
      }
    </div>
  }
  <hr>
    <!-- Multi-window quote banner (v2.6). Shown only when the tape chart
         flex flow gave us multiple date ranges. Makes it explicit to the
         rep that the top-level CheckIn/CheckOut pickers are disabled — the
         actual windows live on each detail row below. -->
    @if (isMultiWindow) {
      <div class="alert alert-info d-flex align-items-center" style="padding:10px 14px; margin-bottom:12px; background:#eef6ff; border:1px solid #b6d4fe; color:#084298; border-radius:6px;">
        <i class="pi pi-calendar-times" style="font-size:18px; margin-right:10px;"></i>
        <div>
          <strong>Multi-window quote</strong>
          &mdash; this quote contains {{ selectedWindows?.length }} date window{{ (selectedWindows?.length || 0) === 1 ? '' : 's' }}.
          Each property row below carries its own check-in / check-out; the top-level dates are not used.
        </div>
      </div>
    }
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="d-flex">
        <div class="col-lg-6">
          <!-- Top-level CheckIn/CheckOut pickers are meaningless in multi-
               window mode (each detail row has its own dates) and reps
               reported the double UI was confusing, so we hide them
               entirely. The banner above already tells the rep what's
               going on, and ngOnInit clears the `required` validators so
               the form still submits with null parent dates. -->
          @if (!isMultiWindow) {
          <div class="d-flex">
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-calendar #checkInDateCal autofocus class="error-bg" placeholder="Select Date" formControlName="checkInDateTime" appendTo="body" selectOtherMonths="true" inputId="checkInDateTime"
                  [showTime]="false" dateMask (mouseup)="onKeyDate($event)" (onSelect)="checkInChange($event)" [minDate]="minDate" [maxDate]="maxDate" [readonlyInput]="false">
                  <ng-template pTemplate="date" let-date>
                    <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
                  </ng-template>
                </p-calendar>
                <label for="checkInDateTime">CheckIn Date</label>
                @for (validation of validationMessages.checkInDateTime; track validation) {
                  <span>
                    @if (form1.get('checkInDateTime').hasError(validation.type) && (form1.get('checkInDateTime').dirty || form1.get('checkInDateTime').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6">
              <span class="p-float-label w-100 mb-3">
                <p-calendar #checkOutDateCal class="error-bg" placeholder="Select Date" formControlName="checkOutDateTime" appendTo="body" selectOtherMonths="true" inputId="checkOutDateTime"
                  [showTime]="false" (onClose)="openGuestModal($event)" dateMask (keyup)="compareDate($event)" (mouseup)="onKeyDateForCheckOutDate($event)" (onSelect)="checkOutChange($event)"
                  selectOtherMonths="true" [defaultDate]="checkOutDateBasedOnCheckinDate" [minDate]="updatedCheckInDate" [maxDate]="maxDate" [readonlyInput]="false">
                  <ng-template pTemplate="date" let-date>
                    <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
                  </ng-template>
                </p-calendar>
                <label for="checkOutDateTime">CheckOut Date</label>
                @for (validation of validationMessages.checkOutDateTime; track validation) {
                  <span>
                    @if (form1.get('checkOutDateTime').hasError(validation.type) && (form1.get('checkOutDateTime').dirty || form1.get('checkOutDateTime').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
          }
          <div class="d-flex">
            <div class="col-lg-6  mb-3">
              <span class="p-float-label w-100">
                <p-dropdown [options]="numAdults" formControlName="numAdults" optionLabel="name" optionValue="value" placeholder="Adults"></p-dropdown>
                <label for="numAdults">Adults</label>
                @for (validation of validationMessages.numAdults; track validation) {
                  <span>
                    @if (form1.get('numAdults').hasError(validation.type) && (form1.get('numAdults').dirty || form1.get('numAdults').touched)) {
                      <small class="p-invalid">{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-6  mb-3">
              <span class="p-float-label w-100">
                <p-dropdown [options]="childrens" formControlName="numChildren" optionLabel="name" optionValue="value" placeholder="Children"></p-dropdown>
                <label for="numChildren">Children</label>
                @for (validation of validationMessages.numChildren; track validation) {
                  <span>
                    @if (form1.get('numChildren').hasError(validation.type) && (form1.get('numChildren').dirty || form1.get('numChildren').touched)) {
                      <small class="p-invalid">{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
          <div class="d-flex">
            <div class="col-lg-6 mb-3">
              <span class="p-float-label w-100 mb-3">
                <p-calendar #expireDateCal class="error-bg" placeholder="Select Date" formControlName="quoteExpirationDateTime" appendTo="body" selectOtherMonths="true" inputId="quoteExpirationDateTime"
                  dateMask [hourFormat]="12" showMeridian="true" [showTime]="true" (keyup)="compareDate($event)" (onSelect)="checkOutChange($event)" selectOtherMonths="true" [minDate]="minDate"
                  [maxDate]="maxDate" [readonlyInput]="false">
                  <ng-template pTemplate="date" let-date>
                    <span style="border-radius:50%; padding: .25em; width: 2em; height: 2em; display:block">{{date.day}}</span>
                  </ng-template>
                </p-calendar>
                <label for="quoteExpirationDateTime">Expire Date</label>
                @for (validation of validationMessages.quoteExpirationDateTime; track validation) {
                  <span>
                    @if (form1.get('quoteExpirationDateTime').hasError(validation.type) && (form1.get('quoteExpirationDateTime').dirty || form1.get('quoteExpirationDateTime').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>
          <!-- ==================================================== -->
          <!--  NEW-GUEST NUDGE BANNER                                 -->
          <!--  Shown when Smart-Parse populated name/email but no     -->
          <!--  existing Guest Master Profile matched. Backend's       -->
          <!--  /quotes/create requires a guestMasterProfileId, so     -->
          <!--  the rep must resolve this (create or find) before      -->
          <!--  Send. "Create Profile" short-circuits to the GMP       -->
          <!--  add dialog pre-populated from the parsed fields.       -->
          <!-- ==================================================== -->
          @if (needsNewGmp) {
            <div class="new-guest-banner" style="
              border: 1px solid #f5c242;
              background: #fff8e1;
              border-radius: 6px;
              padding: 10px 12px;
              margin: 0 0 12px 0;
              display: flex;
              align-items: center;
              gap: 12px;
              flex-wrap: wrap;">
              <i class="pi pi-exclamation-triangle" style="color:#b97a00; font-size:1.2rem;"></i>
              <div style="flex:1; min-width: 220px; color:#333;">
                <strong>New guest detected.</strong>
                No existing Guest Master Profile matches
                @if (pendingNewGuestPrefill?.emailAddress) {
                  <code style="background:#fff; padding:1px 6px; border-radius:4px; margin:0 2px;">{{ pendingNewGuestPrefill.emailAddress }}</code>.
                } @else {
                  this email.
                }
                Create a profile (or find an existing one) before sending the quote.
              </div>
              <button pButton type="button"
                class="p-button-sm"
                style="background-color:#E18131; border-color:#E18131;"
                (click)="createNewGuestFromPrefill()">
                <i class="pi pi-user-plus" style="margin-right:6px;"></i>Create Profile
              </button>
              <button pButton type="button"
                class="p-button-sm p-button-outlined"
                (click)="findGuest()">
                <i class="pi pi-search" style="margin-right:6px;"></i>Find Existing
              </button>
            </div>
          }
          <div class="p-0" formGroupName="guestProfile">
            <div class="row m-0">
              <div class="col-lg-6 mb-3">
                <span class="p-float-label required-field w-100">
                  <input formControlName="firstName" id="firstName" class="disabled-field-textColor" type="text" readonly (click)="findOrEditGuest()" pInputText>
                  <label for="firstName">First Name</label>
                  @for (validation of validationMessages.firstName; track validation) {
                    <span>
                      @if (form1.get('guestProfile.firstName').hasError(validation.type) && (form1.get('guestProfile.firstName').dirty || form1.get('guestProfile.firstName').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>

              <div class="col-lg-6 mb-3">
                <span class="p-float-label required-field w-100">
                  <input formControlName="lastName" id="lastName" class="disabled-field-textColor" type="text" readonly (click)="findOrEditGuest()" pInputText>
                  <label for="lastName">Last Name</label>
                  @for (validation of validationMessages.lastName; track validation) {
                    <span>
                      @if (form1.get('guestProfile.lastName').hasError(validation.type) && (form1.get('guestProfile.lastName').dirty || form1.get('guestProfile.lastName').touched)) {
                        <small class="p-invalid"
                          >{{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
            <div class="col-lg-12">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="emailAddress" id="emailAddress" class="disabled-field-textColor" type="email" readonly (click)="findOrEditGuest()" pInputText>
                <label for="emailAddress">Email Address</label>
                @for (validation of validationMessages.emailAddress; track validation) {
                  <span>
                    @if (form1.get('guestProfile.emailAddress').hasError(validation.type) && (form1.get('guestProfile.emailAddress').dirty || form1.get('guestProfile.emailAddress').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
            <div class="col-lg-12">
              <span class="p-float-label required-field w-100 mb-3">
                <input formControlName="mobilePhone" id="mobilePhone" class="disabled-field-textColor" readonly pInputText (click)="findOrEditGuest()">
                <label for="mobilePhone">Mobile</label>
                @for (validation of validationMessages.mobilePhone; track validation) {
                  <span>
                    @if (form1.get('guestProfile.mobilePhone').hasError(validation.type) && (form1.get('guestProfile.mobilePhone').dirty || form1.get('guestProfile.mobilePhone').touched)) {
                      <small class="p-invalid"
                        >{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </div>
          </div>

        </div>
        <div class="col-lg-6 guest-note-right">
          <div class="col-lg-12">
            <span class="p-float-label required-field w-100 mb-3">
              <span class="p-float-label w-100">
                <textarea class="fixtextarea" formControlName="guestNotes" id="guestNotes" [rows]="2" pInputTextarea></textarea>
                <label for="guestNotes">Guest Notes</label>
                @for (validation of validationMessages.guestNotes; track validation) {
                  <span>
                    @if (form1.get('guestNotes').hasError(validation.type) && (form1.get('guestNotes').dirty || form1.get('guestNotes').touched)) {
                      <small class="p-invalid">{{validation.message}}
                      </small>
                    }
                  </span>
                }
              </span>
            </span>
          </div>
          <div class="d-flex">
            <div class="col-lg-9">
              <label>Send to Guest Method(s)</label>
              <div class="col-lg-12 mt-1">
                <span class="p-float-label required-field w-100 mb-3">
                  <span class="p-float-label w-100 d-flex">
                    <p-checkbox [formControl]="form1.controls['sendEmail']" inputId="sendEmail" [binary]="true"></p-checkbox>
                    <span class="test-nm">Email</span>
                  </span>
                  @for (validation of validationMessages.sendEmail; track validation) {
                    <span>
                      @if (form1.get('sendEmail').hasError(validation.type) && (form1.get('sendEmail').dirty || form1.get('sendEmail').touched)) {
                        <small class="p-invalid">
                          {{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
              <div class="col-lg-12">
                <span class="p-float-label required-field w-100 mb-3">
                  <span class="p-float-label w-100 d-flex">
                    <p-checkbox [formControl]="form1.controls['sendText']" inputId="sendText" [binary]="true"></p-checkbox>
                    <span class="test-nm">Text</span>
                  </span>
                  @for (validation of validationMessages.sendText; track validation) {
                    <span>
                      @if (form1.get('sendText').hasError(validation.type) && (form1.get('sendText').dirty || form1.get('sendText').touched)) {
                        <small class="p-invalid">
                          {{validation.message}}
                        </small>
                      }
                    </span>
                  }
                </span>
              </div>
            </div>
            <div class="col-lg-3">
              <!-- Start drip checkbox — only shown for new quotes (no quoteId yet) -->
              @if (!quote.quoteId) {
                <div class="mb-2 d-flex align-items-center gap-2">
                  <p-checkbox [formControl]="form1.controls['startFollowUpDrip']" inputId="startFollowUpDrip" [binary]="true"></p-checkbox>
                  <label for="startFollowUpDrip" style="margin:0; cursor:pointer;">
                    Start automated follow-up drip campaign (6h / 24h / 72h)
                    <i class="pi pi-info-circle" style="color:#888; margin-left:4px;"
                       pTooltip="If enabled, we'll automatically email the guest at 6 hours, 24 hours, and 72 hours if they don't respond, then create a phone-call task for the agent. Stops automatically if the guest replies or the quote converts to a reservation."
                       tooltipPosition="left"></i>
                  </label>
                </div>
              }
              <div class="button-group">
                <button pButton class="btn-cancel p-button-text mr-1" (click)="findGuest()" [disabled]="formLoading">Find Guest</button>
                <button pButton class="btn-addt p-button"
                        [disabled]="formLoading"
                        (click)="quote.quoteId ? formUpdate() : sendQuote()">
                  @if (formLoading) {
                    <i class="pi pi-spin pi-spinner" style="margin-right:6px;"></i>Sending…
                  } @else {
                    {{ quote.quoteId ? 'Update Quote' : 'Send Quote' }}
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Properties-list loader: addQuoteDetails() runs N parallel
           picture + rate fetches, which take 1–3 seconds. Without this,
           the reservationist saw a blank area and couldn't tell whether
           the backend was working. Stays visible until Promise.all
           resolves and quoteDetailAPIList is populated. -->
      @if (loadingQuoteDetails && (!quoteDetailAPIList || quoteDetailAPIList.controls.length === 0)) {
        <div class="row mt-3 pb-2" style="text-align:center; padding:24px 12px;">
          <div class="d-flex align-items-center justify-content-center" style="gap:12px; color:#555;">
            <p-progressSpinner [style]="{width: '32px', height: '32px'}" strokeWidth="5" animationDuration=".7s"></p-progressSpinner>
            <span>Loading properties and live rates&hellip;</span>
          </div>
        </div>
      }
      @if (quoteDetailAPIList && quoteDetailAPIList.controls && quoteDetailAPIList.controls.length > 0) {
        <div class="row mt-3 pb-2 gap-2">
          <div class="row" style="font-weight: bold;">
            <div class="col-lg-1"></div>
            <div class="col-lg-1">
              Resort
            </div>
            <div class="col-lg-1">
              Property
            </div>
            <!-- Multi-window quote (v2.6): dedicated Check-In / Check-Out /
                 Nights columns. Rendered only when the dialog is in multi-
                 window mode so legacy quotes keep the original layout. -->
            @if (isMultiWindow) {
              <div style="flex:0 0 95px; max-width:95px;" class="px-2">
                Check-In
              </div>
              <div style="flex:0 0 95px; max-width:95px;" class="px-2">
                Check-Out
              </div>
              <div style="flex:0 0 60px; max-width:60px;" class="px-2">
                Nights
              </div>
            }
            <div class="col-lg-1">
              List Price
            </div>
            <div class="col-lg-1 mb-1">
              Discount Price
            </div>
            <div class="col-lg-1 mb-1">
              Discount Pct
            </div>
            <div class="col-lg-1 mb-1">
              Pretax Total
            </div>
            <div class="col-lg-1 mb-1">
              Grand Total
            </div>
            @if (quote.quoteId) {
              <div class="col-lg-1 mb-2">
              </div>
            }
            <div class="col-lg-2 mb-2">
            </div>
            <div class="col-lg-1 mb-1">
            </div>
          </div>
        </div>
      }
      <div class="p-0" formArrayName="quoteDetailAPIList">
        <!-- <div class="row" *ngFor="let property of selectedProperties; index as i"> -->
        @for (quoteDetail of quoteDetailAPIList.controls; track quoteDetail; let i = $index) {
          <div class="row" [formGroupName]="i">
            @if (quoteDetail.value.isAvailable) {
              <div class="row">
                <div class="col-lg-1">
                  @if (quoteDetail.value.thumbImg) {
                    <img [src]="quoteDetail.value.thumbImg" alt="Property Image" style="max-width: 70px; max-height: 70px; width: 100%;">
                  }
                </div>
                <div class="col-lg-1">
                  {{ quoteDetail.get('addressDevelopmentName')?.value }}
                </div>
                <div class="col-lg-1 overflow-text" data-toggle="tooltip" title="{{ quoteDetail.get('propertyCode')?.value }}">
                  {{ quoteDetail.get('propertyCode')?.value }}
                </div>
                <!-- Multi-window quote (v2.6): per-row dates in dedicated
                     columns. Header cells above match these widths exactly.
                     `yearFormat` omitted from the pipe (MMM d) since all
                     three rows of the same quote almost always share the
                     same year — date-only keeps the table compact. -->
                @if (isMultiWindow) {
                  <div style="flex:0 0 95px; max-width:95px;" class="px-2">
                    {{ quoteDetail.get('checkInDateTime')?.value | date:'MMM d, yyyy' }}
                  </div>
                  <div style="flex:0 0 95px; max-width:95px;" class="px-2">
                    {{ quoteDetail.get('checkOutDateTime')?.value | date:'MMM d, yyyy' }}
                  </div>
                  <div style="flex:0 0 60px; max-width:60px;" class="px-2">
                    {{ quoteDetail.get('numNights')?.value }}
                  </div>
                }
                <div class="col-lg-1">
                  {{quoteDetail.get('yieldPrice')?.value  | currency : 'USD' : 'symbol' : '1.2-2'}}
                </div>
                <div class="col-lg-1 mb-1 w-200">
                  <span class="p-float-label required-field w-200">
                    <input formControlName="quotePrice" id="quotePrice" type="text" pInputText>
                    <!--<label for="quotePrice">Discount $</label>-->
                  </span>
                </div>
                <div class="col-lg-1 mb-1">
                  <span class="p-float-label w-150">
                    <p-dropdown [options]="quoteDiscPcts" formControlName="quoteDiscPct" appendTo="body" optionLabel="name" optionValue="value" placeholder="Quote Disc %"
                    (onChange)="updateQuotePrice(i)"></p-dropdown>
                    <!--<label for="quoteDiscPct">Discount %</label>-->
                  </span>
                </div>
                <div class="col-lg-1 mb-1">
                  <span class="p-float-label w-100" (click)="openQuoteWindow(i, quoteDetail.get('propertyCode')?.value)">
                    <a href="javascript:void(0);" class="link-amount">{{quoteDetail.get('grandTotal')?.value | currency : 'USD' : 'symbol' : '1.2-2'}}</a>
                  </span>
                </div>
                <div class="col-lg-1 mb-1">
                  <span class="p-float-label w-100">
                    {{quoteDetail.get('grandTotalWithTax')?.value | currency : 'USD' : 'symbol' : '1.2-2'}}
                  </span>
                </div>
                @if (quote.quoteId) {
                  <div class="col-lg-1 mb-2">
                    <span class="p-float-label w-100">
                      <p-dropdown [options]="quoteStatuses" formControlName="quoteStatus" optionLabel="name" optionValue="value" placeholder="Status"></p-dropdown>
                      <label for="quoteStatus">Status</label>
                    </span>
                  </div>
                }
                <div class="col-lg-2 mb-2">
                  <span class="p-float-label required-field">
                    <span class="p-float-label">
                      <textarea class="fixtextarea" formControlName="guestNotes" id="guestNotes" [rows]="1" pInputTextarea></textarea>
                      <label for="guestNotes">Guest Notes</label>
                    </span>
                  </span>
                </div>
                <div class="col-lg-1 mb-1">
                  <span class="p-float-label required-field w-100">
                    <span class="p-float-label w-100">
                      <a>
                        <i class="pi pi-times" title="Remove" aria-hidden="true" style="color:red; font-size:110%; padding-right:20px;" (click)="removeProperty(i)"></i>
                      </a>
                    </span>
                  </span>
                </div>
              </div>
            }
          </div>
        }
        @if (reservedProperties && reservedProperties.length > 0) {
          <div class="row mt-3 gap-2">
            @for (property of reservedProperties; track property) {
              <div>
                <span class="notavailable">{{property}} is not available between searched date range</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <!-- <div class="row" *ngFor="let property of selectedProperties">
    <div class="col-lg-2">
      {{property.addressDevelopmentName}}
    </div>
    <div class="col-lg-2">
      {{property.propertyCode}}
    </div>
    <div class="col-lg-2">
      {{property?.rates[0]?.rateYieldPriceAMT | currency : 'USD' : 'symbol' : '1.0-0'}}
    </div>
    <div class="col-lg-2">
      <span class="p-float-label required-field w-100">
        <input formControlName="lastName" id="lastName" type="text" pInputText>
        <label for="lastName">Last Name</label>
        <span *ngFor="let validation of validationMessages.lastName">
          <small class="p-invalid"
            *ngIf="form1.get('guestProfile.lastName').hasError(validation.type) && (form1.get('guestProfile.lastName').dirty || form1.get('guestProfile.lastName').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>
  </div> -->
</div>

<!-- ============================================================ -->
<!-- DRIP CAMPAIGN STATUS PANEL                                  -->
<!-- Shown only when an active drip instance exists for this     -->
<!-- quote. Hidden entirely for new (unsaved) quotes.           -->
<!-- ============================================================ -->
@if (quoteId && (dripInstance || dripLoading)) {
  <div class="mt-3 mb-2" style="border:1px solid #dee2e6; border-radius:6px; background:#fafafa;">
    <div class="d-flex align-items-center justify-content-between px-3 py-2"
         style="cursor:pointer; border-bottom:1px solid #dee2e6;"
         (click)="dripPanelCollapsed = !dripPanelCollapsed">
      <span style="font-weight:600; font-size:0.95rem;">
        <i class="pi pi-send" style="margin-right:6px; color:#E18131;"></i>Drip Campaign Status
      </span>
      <i [class]="dripPanelCollapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up'" style="color:#888;"></i>
    </div>
    @if (!dripPanelCollapsed) {
      <div class="px-3 py-2">
        @if (dripLoading) {
          <div class="d-flex align-items-center gap-2 py-2">
            <p-progressSpinner [style]="{width:'20px',height:'20px'}" strokeWidth="5" animationDuration=".7s"></p-progressSpinner>
            <span style="color:#555;">Loading drip status&hellip;</span>
          </div>
        }
        @if (!dripLoading && dripInstance) {
          <div class="row g-2 align-items-start py-1">
            <div class="col-lg-2 col-md-3" style="font-weight:600; color:#555;">Status</div>
            <div class="col-lg-4 col-md-9">
              <span [class]="'badge ' + (dripInstance.status === 'ACTIVE' ? 'bg-success' : dripInstance.status === 'PAUSED' ? 'bg-warning text-dark' : 'bg-secondary')">
                {{ dripInstance.status }}
              </span>
              &nbsp;
              @if (dripInstance.status === 'ACTIVE') {
                <button pButton type="button" class="p-button-sm p-button-outlined p-button-secondary"
                  style="padding:2px 8px; font-size:0.8rem;" (click)="pauseDrip()">Pause</button>
              }
              @if (dripInstance.status === 'PAUSED') {
                <button pButton type="button" class="p-button-sm p-button-outlined p-button-success"
                  style="padding:2px 8px; font-size:0.8rem;" (click)="resumeDrip()">Resume</button>
              }
              @if (dripInstance.status === 'ACTIVE' || dripInstance.status === 'PAUSED') {
                <button pButton type="button" class="p-button-sm p-button-outlined p-button-danger"
                  style="padding:2px 8px; font-size:0.8rem; margin-left:4px;" (click)="cancelDrip()">Cancel</button>
              }
            </div>

            @if (dripInstance.currentStepOrder != null) {
              <div class="col-lg-2 col-md-3" style="font-weight:600; color:#555;">Current step</div>
              <div class="col-lg-4 col-md-9">Step {{ dripInstance.currentStepOrder }}</div>
            }

            @if (dripInstance.nextStepDate) {
              <div class="col-lg-2 col-md-3" style="font-weight:600; color:#555;">Next fire</div>
              <div class="col-lg-4 col-md-9">{{ dripInstance.nextStepDate | date:'MMM d, y h:mm a' }}</div>
            }

            @if (dripInstance.events && dripInstance.events.length > 0) {
              <div class="col-lg-2 col-md-3" style="font-weight:600; color:#555;">Last event</div>
              <div class="col-lg-4 col-md-9">
                {{ dripInstance.events[dripInstance.events.length - 1].eventType }}
                &nbsp;&mdash;&nbsp;
                {{ dripInstance.events[dripInstance.events.length - 1].createDate | date:'MMM d, y h:mm a' }}
              </div>
            }
          </div>
        }
        @if (!dripLoading && !dripInstance) {
          <div class="py-2" style="color:#888; font-size:0.9rem;">No active drip campaign for this quote.</div>
        }
      </div>
    }
  </div>
}

<!-- ============================================================ -->
<!-- FOLLOW-UP TASK LIST                                         -->
<!-- Embedded app-task-list filtered to taskSource=4 (QUOTE)     -->
<!-- and this quote's ID. Hidden for new (unsaved) quotes.       -->
<!-- ============================================================ -->
@if (quoteId) {
  <div class="mt-3 mb-3">
    <app-task-list
      [lockedFilters]="{ taskSource: 4, taskSourceId: quoteId }"
      [defaultAssignee]="form1?.value?.reservationistUserId"
      [showCreateButton]="true"
      [title]="'Follow-up tasks for this quote'">
    </app-task-list>
  </div>
}

<!-- Quote Dialog -->
<p-dialog class="tapechart-quote-popup" header="Quote" [modal]="true" [(visible)]="showQuoteWindow" [position]="position" [style]="{ width: '95vw', 'max-width': '1400px', height: '90vh' }" [maximizable]="true">
  <div class="pl-2 pt-2">
    <b>Property :</b> {{quotePropertyCode}}
  </div>
  <!-- Quote-breakdown loader: the dialog opens instantly, but the full
       invoice comes from a round-trip to /rate-quotes/generate-quote.
       Without this, the rep saw just the "Property : HK-803" header and
       nothing else for 1–2 seconds. Clears as soon as the response
       (or error) lands. -->
  @if (loadingWikiQuote && !formError) {
    <div style="text-align:center; padding:48px 12px;">
      <p-progressSpinner [style]="{width: '48px', height: '48px'}" strokeWidth="5" animationDuration=".7s"></p-progressSpinner>
      <div style="margin-top:12px; color:#555;">Calculating quote breakdown&hellip;</div>
    </div>
  }
  @if (formError) {
    <div>
      <br>
        @if (formError.message) {
          <table class="error-mess d-block">
            <tbody>
              <tr>
                <td class="formError">{{formError.message}}</td>
              </tr>
            </tbody>
          </table>
        }
      </div>
    }
    @if (!formError && !loadingWikiQuote && wikiQuote && wikiQuote.invoice) {
      <div>
        <app-reservation-invoice [quote]="wikiQuote" [showShortInvoiceDetail]="showShortInvoiceDetail" (updateQuote)="showCouponDialog()">
        </app-reservation-invoice>
        <br>
          @if (errorList) {
            <div style="padding:2px;">
              <table style="background-color:white;border:0px solid #ddd; width:100%; text-align: right;font-size: small;">
                <tbody>
                  @for (error of errorList; track error) {
                    <tr>
                      <td style="padding:0px; color:red"><span [innerHtml]="error"></span></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          <!-- <table class="w-100">
          <tr>
            <td style="text-align: right;">
              <input type="button" (click)="onBookNowClick()" mat-raised-button color="accent" [disabled]="formLoading"
                value="Book Now" class="btn-blue-primary btn-green"
                />
            </td>
          </tr>
        </table> -->
      </div>
    }
  </p-dialog>

  <!-- Coupon Dialog -->
  <p-dialog header="Coupon" [(visible)]="showCoupon" [style]="{width: 'auto', height: 'auto'}">
    @if (isSearching == true) {
      <div style="text-align: center;">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
      </div>
    }
    @if (couponCodeSuccessMsg) {
      <div>
        <span style="background-color: white;color: green;">Coupon code amount {{wikiQuote?.couponDiscount}} applied
        successfully</span>
      </div>
    }
    @if (!couponCodeSuccessMsg) {
      <div>
        <input pautofocus="" [(ngModel)]="couponCode" aria-autocomplete="list" role="searchbox" class="p-element ng-tns-c118-14 p-autocomplete-input p-inputtext p-component ng-star-inserted" autocomplete="off"
          type="text" id="autocomplete" placeholder="Enter coupon code">
        &nbsp;&nbsp;
        <a class="nav-btn btn-sm left-icon text-white me-0" (click)="applyCouponCode()" style="background-color: #E18131 !important; color: #fff !important;"><b>Apply
        </b></a><br>
        @if (isCouponCodeIsApply) {
          <div>
            <small class="p-error" style="background-color: white;">Please enter coupon code</small>
          </div>
        }
        @if (!wikiQuote?.couponApplied && invalidCouponCode) {
          <div>
            <small class="p-error" style="background-color: white;">Coupon code is invalid or no longer
            available</small>
          </div>
        }
      </div>
    }
  </p-dialog>